import { ChangeEvent } from 'react'
import _ from 'lodash'
import {
	L2TabularListRoot,
	L2TabularListHeader,
	L2TabularListContent,
	L2TabularListActions,
} from '../l2/L2TabularList'
import {
	L2TabularListItemSummary,
	L2TabularListItemEdit,
	L2TabularListControl,
	L2TabularListControlLabel,
} from '../l2/L2TabularListItem'
import L1TextField from '../l1/L1TextField'
import { L1ReasonableButton } from '../l1/L1Button'
import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { useL4TabularStateReturn } from '../l4/L4TabularList'
import { L4NoPrint } from '../l4/L4Print'
import { ComplexElementSize } from '../ComplexElementSize'

/**
 * WARNING
 * Once this goes to production, these hardcoded models cannot change without
 * discussion, because it would change the form—  and forms are supposed to
 * stay the same from a legal perspective once they start getting used for
 * real data.  Also, JSON based on them will have been recorded into the
 * database and any change may cause loads of previous data to break or render
 * incorrectly.  This will not be an issue once they are being dynamically
 * defined in the Flow XML along with everything else.
 */
export interface L3PatientLabListModel {
	TestName: string,
	Date: string,
	Value: string,
	Source: string,
}

const newModel = (): L3PatientLabListModel => {
	return {
		TestName: '',
		Date: '',
		Value: '',
		Source: '',
	}
}

type L3PatientLabListProps = {} & useL4TabularStateReturn<L3PatientLabListModel>

export const L3PatientLabList = ({models, addModels, updateModel, deleteModel, editIdx, setEditIdx}: L3PatientLabListProps) => {
	const items = _.map(models, (model, modelIdx) => {
		if(editIdx === modelIdx) {
			return (
				<L2TabularListItemEdit
					key={modelIdx}
					onCloseClick={() => setEditIdx(null)}
					onDeleteClick={() => deleteModel(modelIdx)}
				>
					<L2TabularListControl>
						<L2TabularListControlLabel>Test Name</L2TabularListControlLabel>
						<L1TextField
							value={model.TestName}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'TestName', e.target.value)}
						/>
					</L2TabularListControl>
					<L2TabularListControl>
						<L2TabularListControlLabel>Date</L2TabularListControlLabel>
						<L1TextField
							inputType="date"
							value={model.Date}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Date', e.target.value)}
						/>
					</L2TabularListControl>
					<L2TabularListControl>
						<L2TabularListControlLabel>Value</L2TabularListControlLabel>
						<L1TextField
							value={model.Value}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Value', e.target.value)}
							size={ComplexElementSize.Min}
						/>
					</L2TabularListControl>
					<L2TabularListControl>
						<L2TabularListControlLabel>Source</L2TabularListControlLabel>
						<L1TextField
							value={model.Source}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Source', e.target.value)}
						/>
					</L2TabularListControl>
				</L2TabularListItemEdit>
			)
		} else {
			return (
				<L2TabularListItemSummary
					key={modelIdx}
					onClick={() => setEditIdx(modelIdx)}
				>
					<div>{model.TestName}</div>
					<div>{model.Date}</div>
					<div>{model.Value}</div>
					<div>{model.Source}</div>
				</L2TabularListItemSummary>
			)
		}
	})
	return (
		<L2TabularListRoot columnCount={5}>
			<L2TabularListHeader>
				<div>Test Name</div>
				<div>Date</div>
				<div>Value</div>
				<div>Source</div>
			</L2TabularListHeader>
			<L2TabularListContent>
				{items}
			</L2TabularListContent>
			<L2TabularListActions>
				<L4NoPrint>
					<L1ReasonableButton icon={faPlus} label="Add" onClick={() => addModels([newModel()], true)} />
				</L4NoPrint>
			</L2TabularListActions>
		</L2TabularListRoot>
	)
}
